import { Card } from 'rebass/styled-components'
import styled from 'styled-components';


const HoverCard = styled(Card)`
  transition:all 0.3s ease;
  flex: initial;
`
interface IHoverableCardProps {
  hoveredId: string | null | undefined
  id: string,
  style: React.CSSProperties,
  setHover: (id: string | null) => void
  onClick?: () => void
  isEmbed?:boolean
}

export const HoverableCard: React.FC<IHoverableCardProps> = ({isEmbed, style, hoveredId, id, setHover, children, onClick = () => { } }) => {
  return (
    <HoverCard
      onClick={onClick}
      mb={2}
      style={{
        opacity: !hoveredId || hoveredId === id ? 1 : 0.7,
        boxShadow: !hoveredId || hoveredId === id ? '0px 4px 20px rgb(0 0 0 / 10%)' : '0px 4px 20px rgb(0 0 0 / 0%)',
        padding: isEmbed?'12px':'',
        ...style
      }}
      onMouseEnter={() => setHover(id)} onMouseLeave={() => setHover(null)}>
      {children}
    </HoverCard>);
}